import React from "react";

import DataStore from "./data.Store";
class RootStore {

  dataStore: DataStore
  constructor () {
    this.dataStore = new DataStore();
  }
}

const rootStore = new RootStore();

const context = React.createContext(rootStore);

const useStore = () => React.useContext(context);


export { useStore };
